import React, { useCallback, useEffect, useState } from 'react';

import SelectControlled from '../SelectControlled';

const API_URL = 'https://www.datos.gov.co/resource/gdxc-w37w.json?$limit=1200';

const CitiesSelector = ({ controlledProps, watch }) => {
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [cities, setCities] = useState([]);

  const selectedHookDepartment = watch('state_code');

  const getDepartamentos = useCallback(async () => {
    const res = await fetch(API_URL);
    const data = await res.json();

    // Obtener departamentos únicos por código
    const departamentosMap = new Map();
    data.forEach(item => {
      if (!departamentosMap.has(item.cod_dpto)) {
        departamentosMap.set(item.cod_dpto, item.dpto);
      }
    });

    // Convertir a array [{ cod_depto, nom_depto }]
    const departamentos = Array.from(departamentosMap, ([cod_dpto, dpto]) => ({
      code: cod_dpto,
      name: dpto
    }));

    // Ordenar alfabéticamente
    departamentos.sort((a, b) => a.name.localeCompare(b.name));

    setDepartments(departamentos);
  }, []);

  useEffect(() => {
    getDepartamentos();
  }, [getDepartamentos]);

  async function getMunicipiosPorDepartamento(cod_dpto) {
    // Aseguramos cod_dpto como string y escapamos
    const cod = String(cod_dpto).replace(/'/g, "''");
    const where = encodeURIComponent(`cod_dpto='${cod}'`);
    // ordenamos por nombre de municipio (nom_mpio o nom_mpio)
    const order = encodeURIComponent('nom_mpio');
    const url = `${API_URL}&$where=${where}&$order=${order}`; // límite alto para cubrir todos

    const res = await fetch(url);
    const data = await res.json();
    // Retornar solo nombre y código de municipio
    const municipios = data.map(item => ({
      cod_mpio: item.cod_mpio,
      nom_mpio: item.nom_mpio
    }));

    // Ordenar por nombre
    municipios.sort((a, b) => a.nom_mpio.localeCompare(b.nom_mpio));

    setCities(municipios);
  }

  useEffect(() => {
    if (selectedHookDepartment) {
      setSelectedDepartment(selectedHookDepartment);
    }
  }, [selectedHookDepartment]);

  useEffect(() => {
    if (selectedDepartment) {
      getMunicipiosPorDepartamento(selectedDepartment);
    }
  }, [selectedDepartment]);

  return (
    <div>
      <SelectControlled
        name={'state_code'}
        {...controlledProps}
        title={'DEPARTAMENTO'}
        onChange={e => setSelectedDepartment(e.target.value)}
        options={departments.map(dep => (
          <option key={dep.code} value={dep.code}>
            {dep.name}
          </option>
        ))}
      />
      <SelectControlled
        name={'city_code'}
        {...controlledProps}
        title={'CIUDAD'}
        disabled={!selectedDepartment}
        options={cities?.map(city => (
          <option key={city.cod_mpio} value={city.cod_mpio}>
            {city.nom_mpio}
          </option>
        ))}
      />
    </div>
  );
};

export default CitiesSelector;
